import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TableIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Table",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M26.37 4.2H5.63C3.63 4.2 2 5.83 2 7.83v16.34c0 2 1.63 3.63 3.63 3.63h20.74c2 0 3.63-1.63 3.63-3.63V7.83c0-2-1.63-3.63-3.63-3.63m.52 7.26v5.06h-9.33v-5.06zm-12.44 0v5.06H5.11v-5.06h9.33ZM5.64 24.68c-.28 0-.51-.23-.51-.51v-4.54h9.33v5.06H5.63Zm20.74 0h-8.81v-5.06h9.33v4.54c0 .29-.23.52-.52.52"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M28.14 21.29H3a1.14 1.14 0 1 1 0-2.28h25.14a1.14 1.14 0 1 1 0 2.28M28.14 13.29c-.63 0-1.14-.51-1.14-1.14V5.29c0-.63-.51-1.14-1.14-1.14H5.29c-.63 0-1.14.51-1.14 1.14v6.86a1.14 1.14 0 1 1-2.28 0V5.29c0-1.89 1.54-3.43 3.43-3.43h20.57c1.89 0 3.43 1.54 3.43 3.43v6.86c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M25.86 29.29H5.29c-1.89 0-3.43-1.54-3.43-3.43V12.15c0-.63.51-1.14 1.14-1.14h25.14c.63 0 1.14.51 1.14 1.14v13.71c0 1.89-1.54 3.43-3.43 3.43Zm-21.72-16v12.57c0 .31.12.59.33.81s.5.33.81.33h20.57c.63 0 1.14-.51 1.14-1.14V13.29z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.57 29.29c-.63 0-1.14-.51-1.14-1.14V12.14a1.14 1.14 0 1 1 2.28 0v16c0 .63-.51 1.14-1.14 1.14Z"
      })]
    })
  }));
};
TableIcon.displayName = 'TableIcon';